export const ceilTimeToNearestQuarter = (time: Date) => {
  const timeToReturn = new Date(time);
  timeToReturn.setMilliseconds(0);
  timeToReturn.setSeconds(0);
  timeToReturn.setMinutes(Math.ceil(timeToReturn.getMinutes() / 15) * 15);
  return timeToReturn;
};

/**
 * in case that API returns time in past, change it to now
 * @param earliestPickup
 */
export const getEarliestPickupDate = (earliestPickup: Date) => {
  const now = new Date();
  return earliestPickup > now ? earliestPickup : now;
};
